<template>
    <svg class="exit-svg" 
    width=24 
    height=24
    viewBox="0 0 20 20"
    >
        <circle class="circle" cx="10" cy="10" r="10"/>
        <line class="line" x1="4.75" y1="15.25" x2="15.25" y2="4.75"/>
        <line class="line" x1="4.75" y1="4.75" x2="15.25" y2="15.25"/>

    </svg>
</template>

<script setup>
import { useSemanticColors } from '@/composables/useStyleVariables';

const { buttonColors } = useSemanticColors();

</script>

<style scoped>

.exit-svg {
    width: auto;
    cursor: pointer;

}

.line {
    fill: none;
    stroke: v-bind('buttonColors.neutralLight');
    stroke-linecap: round;
    stroke-miterlimit: 10;
    stroke-width: 2px;
}

.circle {
    fill: v-bind('buttonColors.neutralDark');
}

.exit-svg:hover .line {
    stroke: v-bind('buttonColors.hover');
}

</style>
